import React, { useContext, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus as Plus } from '@fortawesome/free-solid-svg-icons';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from 'reactstrap';

import AppContext from '../AppContext';

function NewItemView({ addItem, className, iconClassName, maxTitleLength, maxContentLength }) {
  const { t } = useContext(AppContext);
  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleSave = async () => {
    try {
      await addItem(title, content);
      setTitle('');
      setContent('');
      setShowModal(false);
    } catch (e) {
      console.log(e);
      alert(e.message);
    }
  };

  const handleCancel = () => {
    setTitle('');
    setContent('');
    setShowModal(false);
  };

  return (
    <>
      <div className={className} onClick={handleOpenModal}>
        <FontAwesomeIcon className={iconClassName} icon={Plus} title={t('title.newItem')} />
      </div>

      <Modal isOpen={showModal} toggle={handleCancel}>
        <ModalHeader toggle={handleCancel}>{t('title.newItem')}</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="itemTitle">{t('title.titleCharLimit', {maxTitleLength})}</Label>
            <Input type="text" id="itemTitle" value={title} onChange={e => setTitle(e.target.value)} maxLength={maxTitleLength} />
          </FormGroup>
          <FormGroup>
            <Label for="itemContent">{t('title.contentCharLimit', {maxContentLength})}</Label>
            <Input type="textarea" id="itemContent" value={content} onChange={e => setContent(e.target.value)} maxLength={maxContentLength} />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleSave} disabled={!title || !content}>
            Save
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default NewItemView;
